// extracted by mini-css-extract-plugin
module.exports = {"Violet_Border_Button":"Button1_Violet_Border_Button__wQ2w_","button_text":"Button1_button_text__3eR__"};